import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fetch-status-text" }


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingState',
  props: {
    loading: { type: Boolean, default: false },
    message: { default: "" },
    errorMessage: { default: "" },
    spinnerSize: { default: 18 },
    spinnerWidth: { default: 2 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fetch-status", { 'is-error': Boolean(__props.errorMessage) && !__props.loading }])
  }, [
    (__props.loading)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          size: __props.spinnerSize,
          width: __props.spinnerWidth,
          color: "primary"
        }, null, 8, ["size", "width"]))
      : (__props.errorMessage)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 1,
            size: __props.spinnerSize,
            color: "error"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" mdi-alert-circle-outline ", -1)
            ]))]),
            _: 1
          }, 8, ["size"]))
        : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.errorMessage || __props.message), 1)
  ], 2))
}
}

})